import styled from "styled-components"

import Div from "../div/div.component"

export const BaseCard = styled(Div)`
  box-shadow: 1px 2px 20px rgba(19, 15, 235, 0.1);
  background-color: ${({ theme: { colors } }) => colors.white};
  border-radius: 3px;
`
